// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mainArea {\n  display: flex;\n  gap: 17px;\n  align-items: center;\n  justify-content: space-between;\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainArea": "mainArea"
};
module.exports = ___CSS_LOADER_EXPORT___;
